// Define a class for the Swiper component that extends the HTMLElement class
class SwiperComponent extends HTMLElement {
  // The constructor is called when an object is created with the class
  constructor() {
    super(); // Call the parent class constructor
  }

  // connectedCallback is a lifecycle method that is called when the custom element is first connected to the document's DOM
  connectedCallback() {
    this.initSwiper(); // Initialize the Swiper when the component is connected
  }

  // Method to initialize the Swiper
  initSwiper() {
    // Define the options for the Swiper
    const swiperOptions = {
      slidesPerView: 1, // Number of slides per view
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true
      }
    };
    // Initialize the Swiper with the options
    new Swiper(this, swiperOptions);
  }
}

// Define the custom element
customElements.define("products-swiper-component", SwiperComponent);

class GridSwatchs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.render();
  }

  render() {
    return;
    // Implementation of rendering logic will go here

    // Assuming swatch element has the class "product-item__swatches__count"
    const swatchElement = this.querySelector('.product-item__swatches__count');

    swatchElement.addEventListener('mouseover', () => {
      // Add the "selected-area" class to the grid-swatch container on mouseover
      this.classList.add('selected-area');
    });

    swatchElement.addEventListener('click', () => {
      // Add the "selected-area" class to the grid-swatch container on mouseover
      this.classList.add('selected-area');
      this.classList.add('disabled-area');
      setTimeout(()=>{
        this.classList.remove('disabled-area');
      },500)
    });

    this.addEventListener('mouseleave', () => {
      // Remove the "selected-area" class from the grid-swatch container on mouseout
      this.classList.remove('selected-area');
    });
  }
}

customElements.define('grid-swatch', GridSwatchs);


class LinkItem extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.render();
  }

  render() {
    this.addEventListener('click', () => {
      window.location.href=this.dataset['href']
    });
  }
}
customElements.define('link-item', LinkItem);


class InventoryTracker extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.render(this.dataset['currentId']);
    
    window.addEventListener('PRODUCT:VARIANT_CHANGE', (e)=>{
      this.render(e.detail.variant.id);
    });
  }

  render(variantId) {
    // Implementation of rendering logic will go here
      const variants = JSON.parse(this.dataset['inventory']);
      variants.forEach(variant=>{
        if(variant.id.toString()==variantId){
          this.classList.remove('low')
          this.classList.remove('unavailable')
          this.classList.remove('available')
          this.classList.remove('onereman')
          if(variant.quantity==0 || variant.quantity==-1 ){
            this.classList.add('unavailable')
          }
          else if(variant.quantity>parseInt(this.dataset['tracker'])){
            this.classList.add('available')
          }
          else if (variant.quantity == 1 && Boolean(this.dataset['enableOneRemaining'])) {
            this.classList.add('onereman');
          } else if (variant.quantity <= parseInt(this.dataset['tracker'])) {
            this.classList.add('low');
            this.querySelector('.for-low .text-inventory').innerText = `LOW IN STOCK`;
          }
        }
      })
  }
}

customElements.define('inventory-tracker', InventoryTracker);


class KlaviyoFormComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.form = this.querySelector('.form-klaviyo-newsletter');
    this.form.addEventListener('submit', this.onSubmit.bind(this));
  }

  onSubmit(event) {
    event.preventDefault();
    // Add any additional logic or validation here
    
    const emailInput = this.form.querySelector('input[name="contact[email]"]').value;

    const url = 'https://a.klaviyo.com/client/subscriptions/?company_id=QVA3LY';

    const data = {
      data: {
        type: "subscription",
        attributes: {
          list_id: "XbMZG8",
          email: emailInput,
        }
      }
    };

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Revision': '2023-06-15'
      },
      body: JSON.stringify(data)
    })
      .then(data => {
        if(data.ok){
          this.querySelector('.form_on_success').style.display = "block";
          this.querySelector('.fieldset-with-submit').style.display = "none";
        }
        else{
          this.querySelector('.form_on_danger').style.display = "block";
          const submitButton = this.form.querySelector('button[type="submit"]');

        }
      })
      .catch(errors => {
        this.querySelector('form-klaviyo-newsletter .form_on_danger').style.display = "block";
        const submitButton = this.form.querySelector('button[type="submit"]');
        submitButton.setAttribute('aria-busy', 'false');
      });
  }
}

customElements.define('form-klaviyo-newsletter', KlaviyoFormComponent);